import { Button, ButtonProps } from "@chakra-ui/react";
import { CSSObject } from "styled-components";
import { forwardRef } from 'react';

type Props = {
    backgroundColor: CSSObject['backgroundColor'];
    _hover: CSSObject;
    text: string;
    width?: string;
    height?: string;
    marginRight?: string;
    onClick?: () => void; 
    color?: string;
} & ButtonProps

const ActionButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {

    return (
        <Button
            backgroundColor={props.backgroundColor}
            _hover={props._hover}
            borderRadius='22px'
            color={props.color ?? 'white'}
            fontWeight='400'
            flexShrink='0'
            width={props.width}
            height={props.height}
            marginRight={props.marginRight}
            fontFamily='KFAGothic'
            onClick={props.onClick} 
            type={props.type}
            ref={ref}
        >
            {props.text}
        </Button>
    )
})

export default ActionButton;
